import { getCurrentUser } from '../../services/CurrentUser';
import { isFeatureAvailable, isFeatureEnabled } from '../../services/Features';
import { hasBasicHr } from '../../services/User';

export type AiCoachLimits = {
    maxCoaches: number | 'UNLIMITED';
    maxResources: number | 'UNLIMITED';
};

export function isAiCoachAvailable(): boolean {
    return isFeatureAvailable('FEATURE_aiCoach') || isFeatureAvailable('FEATURE_aiCoachUnlimited');
}

export function shouldShowAiCoach(context: 'clippy' | 'workspace'): boolean {
    const user = getCurrentUser();
    const userCanPreview = hasBasicHr(user) || user.isSmallImprovements;

    const coachForAllUsers = isFeatureEnabled('FEATURE_aiCoach');
    const flagEnabledForContext =
        (context === 'clippy' && isFeatureEnabled('FEATURE_aiCoachClippy')) ||
        (context === 'workspace' && isFeatureEnabled('FEATURE_aiCoachWorkspace'));
    const aiEnabledGlobally = isFeatureEnabled('ai-features');

    // To be removed when AI coach is live
    if (isFeatureEnabled('FEATURE_aiCoachUpsell')) {
        return aiEnabledGlobally && (userCanPreview || (coachForAllUsers && flagEnabledForContext));
    } else {
        return aiEnabledGlobally && userCanPreview && flagEnabledForContext;
    }
}

export function shouldDisplayAdminOnlyInformation(): boolean {
    const user = getCurrentUser();
    const userIsHr = hasBasicHr(user);
    const coachForAllUsers = isFeatureEnabled('FEATURE_aiCoach');

    if (!coachForAllUsers && userIsHr) {
        return true;
    } else {
        return false;
    }
}

export function getAiCoachLimits(): AiCoachLimits {
    const currentCompanySettings = getCurrentUser().company.companySettings;

    if (isFeatureAvailable('FEATURE_aiCoachUnlimited') || !isFeatureEnabled('FEATURE_aiCoachUpsell')) {
        return { maxCoaches: 'UNLIMITED', maxResources: 'UNLIMITED' };
    } else {
        return { maxCoaches: currentCompanySettings.maxAiCoaches, maxResources: currentCompanySettings.maxAiResources };
    }
}
